import { c as _c } from "react/compiler-runtime";
import MinimalHeader from "@components/MinimalHeader";
import useLanguage from "@lib/hooks/useLanguage";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import { getBudgetCheckPath, getPartnerBudgetCheckPath, getPartnerSearchProfileBudgetCheckPath } from "@lib/routing";
import ApplicationStepHeader from "@modules/application/components/ApplicationStepHeader";
import BudgetCheckDynamicForm from "@modules/application/components/BudgetCheckDynamicForm";
import { FormState } from "@modules/application/context/ApplicationContext";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import useSteps from "@modules/application/hooks/useSteps";
import getBudgetCheckSteps from "@modules/application/lib/budgetCheck";
import { BudgetCheckFormValues, BudgetCheckStepId } from "@modules/application/lib/budgetCheck/types";
import { useTranslation } from "next-i18next";
import { useRouter } from "@lib/hooks/useRouter";
import { FC, useEffect, useMemo, useRef } from "react";
import ApplicationSteps from "../../components/ApplicationSteps";
import SplitLayout from "../../components/SplitLayout";
interface BudgetCheckProps {
  stepId: string;
  withSearchProfile?: boolean;
}
const BudgetCheck: FC<BudgetCheckProps> = t0 => {
  const $ = _c(46);
  const {
    stepId,
    withSearchProfile: t1
  } = t0;
  const withSearchProfile = t1 === undefined ? false : t1;
  const {
    t
  } = useTranslation("budget-check");
  const {
    partner
  } = usePartnerContext();
  const {
    state,
    dispatch
  } = useApplicationContext();
  const locale = useLanguage();
  const ref = useRef(null);
  const router = useRouter();
  const t2 = !!state.lead?.id;
  const t3 = partner?.slug;
  let t4;
  if ($[0] !== locale || $[1] !== t || $[2] !== t2 || $[3] !== t3 || $[4] !== withSearchProfile) {
    t4 = getBudgetCheckSteps(t, locale, false, t2, t3, withSearchProfile);
    $[0] = locale;
    $[1] = t;
    $[2] = t2;
    $[3] = t3;
    $[4] = withSearchProfile;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const steps = t4;
  let t5;
  if ($[6] !== dispatch || $[7] !== locale || $[8] !== partner || $[9] !== router || $[10] !== state.budgetCheckFormState || $[11] !== stepId || $[12] !== steps || $[13] !== withSearchProfile) {
    t5 = {
      stepId,
      steps,
      formState: state.budgetCheckFormState,
      hasZeroStep: false,
      onInvalidState() {
        if (steps[0]) {
          router.replace({
            pathname: router.pathname,
            query: {
              ...router.query,
              stepId: steps[0].id
            }
          });
        }
      },
      onSetForm(form) {
        dispatch({
          type: "SET_BUDGET_CHECK_FORM_STATE",
          form
        });
      },
      onStepChange(step) {
        let routerAction = router.push;
        if (step.id === BudgetCheckStepId.result) {
          routerAction = router.replace;
        }
        if (partner?.id) {
          if (withSearchProfile) {
            routerAction(getPartnerSearchProfileBudgetCheckPath(locale, partner.id, step.id));
          } else {
            routerAction(getPartnerBudgetCheckPath(locale, partner.id, step.id));
          }
        } else {
          routerAction(getBudgetCheckPath(locale, step.id));
        }
      },
      onGoBack(stepId_0) {
        if (stepId_0) {
          if (partner?.id) {
            router.push(getPartnerBudgetCheckPath(locale, partner.id, stepId_0));
          } else {
            router.push(getBudgetCheckPath(locale, stepId_0));
          }
        } else {
          router.back();
        }
      }
    };
    $[6] = dispatch;
    $[7] = locale;
    $[8] = partner;
    $[9] = router;
    $[10] = state.budgetCheckFormState;
    $[11] = stepId;
    $[12] = steps;
    $[13] = withSearchProfile;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const formSteps = useSteps(t5);
  let t6;
  if ($[15] !== formSteps.currentStepNumber) {
    t6 = [formSteps.currentStepNumber];
    $[15] = formSteps.currentStepNumber;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(_temp, t6);
  const Component = formSteps.currentStep.component || BudgetCheckDynamicForm;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MinimalHeader showTopBar={false} />;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = formSteps.currentStepNumber + 1;
  let t9;
  if ($[18] !== formSteps.currentStep || $[19] !== formSteps.handlePreviousStep || $[20] !== formSteps.nextSteps || $[21] !== formSteps.value || $[22] !== t8) {
    t9 = <SplitLayout.Aside><ApplicationSteps onPrevious={formSteps.handlePreviousStep} steps={formSteps.nextSteps} state={t8} step={formSteps.currentStep} value={formSteps.value} /></SplitLayout.Aside>;
    $[18] = formSteps.currentStep;
    $[19] = formSteps.handlePreviousStep;
    $[20] = formSteps.nextSteps;
    $[21] = formSteps.value;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = formSteps.currentStepNumber + 1;
  const t11 = formSteps.currentStepNumber + 1;
  let t12;
  if ($[24] !== formSteps.currentStep.config || $[25] !== formSteps.value || $[26] !== t11) {
    t12 = <ApplicationStepHeader config={formSteps.currentStep.config} currentStepNumber={t11} value={formSteps.value} />;
    $[24] = formSteps.currentStep.config;
    $[25] = formSteps.value;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== Component || $[29] !== formSteps.currentStep || $[30] !== formSteps.currentStepNumber || $[31] !== formSteps.handleNextStep || $[32] !== formSteps.handlePreviousStep || $[33] !== formSteps.nextSteps || $[34] !== formSteps.numberOfSteps || $[35] !== formSteps.value) {
    t13 = <div ref={ref} className="scroll-m-[148px] m:scroll-m-5xl"><Component steps={formSteps.nextSteps} onPrevious={formSteps.handlePreviousStep} onNext={formSteps.handleNextStep} numberOfSteps={formSteps.numberOfSteps} hasZeroStep={false} currentStepNumber={formSteps.currentStepNumber} step={formSteps.currentStep} value={formSteps.value} /></div>;
    $[28] = Component;
    $[29] = formSteps.currentStep;
    $[30] = formSteps.currentStepNumber;
    $[31] = formSteps.handleNextStep;
    $[32] = formSteps.handlePreviousStep;
    $[33] = formSteps.nextSteps;
    $[34] = formSteps.numberOfSteps;
    $[35] = formSteps.value;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== formSteps.currentStepNumber || $[38] !== formSteps.numberOfSteps || $[39] !== t10 || $[40] !== t12 || $[41] !== t13) {
    t14 = <SplitLayout.Body currentStepNumber={t10} numberOfSteps={formSteps.numberOfSteps} state={formSteps.currentStepNumber}>{t12}{t13}</SplitLayout.Body>;
    $[37] = formSteps.currentStepNumber;
    $[38] = formSteps.numberOfSteps;
    $[39] = t10;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t9) {
    t15 = <SplitLayout>{t7}<SplitLayout.Content>{t9}{t14}</SplitLayout.Content></SplitLayout>;
    $[43] = t14;
    $[44] = t9;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
};
export default BudgetCheck;
function _temp() {
  window.scrollTo(0, 0);
}